/**
 * @generated SignedSource<<5336059c2f844c28ba8f600bf6b5329c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedFeaturedModuleCarousel_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemTilesCarousel_user">;
  readonly " $fragmentType": "HpSharedFeaturedModuleCarousel_user";
};
export type HpSharedFeaturedModuleCarousel_user$key = {
  readonly " $data"?: HpSharedFeaturedModuleCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedFeaturedModuleCarousel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedItemTilesCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "0e5eedbb2bbf8b34a6de12c709329a40";

export default node;
